/**
 * Dzieli długi tekst wyposażenia na sekcje wg nagłówków "Nazwa:".
 */
export function parseFeatureSections(raw) {
  if (!raw || typeof raw !== 'string') return [];
  const text = raw.trim();
  if (!text) return [];

  const lines = text.split(/\r?\n/).map((l) => l.trim());
  const nonEmpty = lines.filter(Boolean);
  if (nonEmpty.length === 0) return [];

  const headerMatch = (line) => {
    const m = line.match(/^(.+?):\s*(.*)$/);
    if (!m) return null;
    const left = m[1].trim();
    const right = m[2].trim();
    if (left.length > 72) return null;
    if (/\.[ \t]/.test(left)) return null;
    return { title: left, rest: right };
  };

  const sections = [];
  let current = { title: null, lines: [] };

  const pushCurrent = () => {
    const body = current.lines.join('\n').trim();
    if (current.title || body) {
      sections.push({ title: current.title, body });
    }
    current = { title: null, lines: [] };
  };

  for (const line of nonEmpty) {
    const hm = headerMatch(line);
    if (hm) {
      if (hm.rest) {
        pushCurrent();
        sections.push({ title: hm.title, body: hm.rest });
        current = { title: null, lines: [] };
      } else {
        pushCurrent();
        current = { title: hm.title, lines: [] };
      }
    } else {
      current.lines.push(line);
    }
  }
  pushCurrent();

  if (sections.length > 0) return sections;
  return [{ title: null, body: text }];
}

export function splitDescriptionParagraphs(raw) {
  if (!raw || typeof raw !== 'string') return [];
  return raw
    .trim()
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}

/**
 * Dzieli treść sekcji „Wyposażenie” na pojedyncze punkty (wiersze / średniki).
 */
export function splitSectionBodyToItems(body) {
  if (!body || typeof body !== 'string') return [];
  const raw = body.trim();
  if (!raw) return [];

  let chunks = raw.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);

  if (chunks.length === 1) {
    const one = chunks[0];
    if (one.length > 100 && one.includes(';')) {
      chunks = one.split(/\s*;\s*/).map((s) => s.trim()).filter(Boolean);
    }
  }

  return chunks
    .map((line) => line.replace(/^[\u2022\u2023\u25CF·\-–*]\s*/, '').trim())
    .filter((s) => s.length > 0);
}
